import * as d3se from 'd3-selection'
import * as d3g from 'd3-geo'
import { $, $$, round, numberWithCommas } from './util'
import data from '../server/data_new_deprivation.json'
import gb from '../server/gb_simple_2.json'
import centroids from '../server/centroids.json'
import Tracker from  './tracker.js'

const d3 = Object.assign({}, d3se, d3g)

let tracker

try { tracker = Tracker() } catch (err) { console.log(err) }

const isMobile = window.matchMedia('(max-width: 479px)').matches

const getQueryParameters = function() {
    return document.location.search.replace(/(^\?)/, '').split("&").map(function(n) { return n = n.split("="), this[n[0]] = n[1], this }.bind({}))[0];
}

const splitCopy = str => {

    return str
        .split('\n')
        .filter( str => str.trim() !== '' )
        .map( str => `<p>${str}</p>` )
        .join('')

}

function ordinal(i) {

	if(i === 1) { return '1st' }
	if(i === 2) { return '2nd' }
	if(i === 3) { return '3rd' }

    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}

const drawMap = entry => {

    const mapEl = $('.ge-map')
    const width = mapEl.getBoundingClientRect().width
    const height = width*1.5

    const map = d3.select(mapEl)
        .attr('width', width)
        .attr('height', height)

    const proj = d3.geoAlbers()
        .center([0, 55.4])
        .rotate([4.4, 0])
        .parallels([50, 60])
        .fitSize([ width, height ], gb)

    const path = d3.geoPath().projection(proj)

    const gbShape = map.append('path')
        .attr('d', path(gb))
        .attr('class', 'ge-gbshape')

    const f = centroids.features.find( f => f.properties.pcon17cd === entry.ons_id )

    const wpcShape = 

    map.append('circle')
        .attr('cx', proj(f.geometry.coordinates)[0])
        .attr('cy', proj(f.geometry.coordinates)[1])
        .attr('r', 3)
        .attr('class', 'ge-wpcshape ' + 'ge-fill--' + entry.y2017_winner.toLowerCase().replace(/\s/g, ''))

}

const datapoints = [

    {
        type : 'special',
        label : 'Previous elections',
        format : (row, div) => {

            const data = [ 'y2017_winner', 'y2015_winner', 'y2010_winner' ].reverse()

            const wrapper = div.append('div').attr('class', 'ge-elex-wrapper')

            const divs = wrapper
                .selectAll('blah')
                .data( data )
                .enter()
                .append('div')
                .attr('class', 'ge-elex')

            divs
                .append('span')
                .attr('class', d => 'ge-elex__sq ge-background--' + row[d].toLowerCase().replace(/\s/g, ''))

            divs
                .append('h3')
                .text( d => row[d] )
                .attr('class', 'ge-elex__winner')

            divs
                .append('h3')
                .text( d => d.slice(1, 5) )
                .attr('class', 'ge-elex__year')

        }
    },

    {
        key : 'brexit_leave',
        url : 'leave',
        label : 'Leave vote',
        format : function(d) {
            return round(d*100, 0) + '%'
        }
    },
    {
        key : 'y2017_majority',
        url : 'majority',
        label : 'Majority (2017)',
        format : d => numberWithCommas(d)
    },
    {
        key : 'unemployed',
        url : 'unemployment',
        label : 'Unemployment rate',
        format : d => round(d*100, 1) + '%'
    },
    {
        key : 'income',
        url : 'income',
        label : 'Average income',
        format : d => '£' + numberWithCommas(d)
    },
    {
        key : 'deprivation_rank_uk',
        url : 'deprivation',
        label : 'Deprivation rank',
        description : 'A higher rank means an area is more deprived (lacking income, employment, access to healthcare or education).',
        format : d => d + '<span class="ge-650">/650</span>'
    }
]

const lookup = {
    Con : 'Conservative',
    Lab : 'Labour'
}

function generate (entry, copy, params) {

    const container = $('.ge-embed')

    $('.ge-constname').innerHTML = entry.name

    $('.ge-mp__sq').classList.add('ge-background--' + entry.y2017_winner.toLowerCase().replace(/\s/g, ''))

    $('.ge-mp__party').innerHTML = entry.y2017_winner
    $('.ge-mp__name').innerHTML = entry.y2017_candidate_name + ' MP'

    const split = splitCopy(copy)

    $('.ge-copy').innerHTML = split

    datapoints.forEach( obj => {

        console.log(params[obj.url])

        if(params[obj.url] && params[obj.url].toLowerCase() === 'false') {
            return
        }

        const div = d3.select('.ge-data')
            .append('div')
            .attr('class', 'ge-datapoint')

        const innerDiv = div
            .append('div')
            .attr('class', 'ge-datapoint__inner')

        if((!obj.type || obj.type !== 'special') && (!entry[obj.key] || entry[obj.key] === 'NA')) {
            innerDiv.classed('ge-hidden', true)
        }

        innerDiv.append('h4')
            .attr('class', 'ge-datalabel')
            .text( obj.label )

        if(obj.type && obj.type === 'special') {

            div.classed('ge-fullwidth', true)

            obj.format(entry, innerDiv)

        } else {


        if(obj.description) {

            div.classed('ge-fullwidth', true)

            innerDiv
                .append('p')
                .attr('class', 'ge-datadescr')
                .text( obj.description )
        }
        

        innerDiv.append('h3')
                .attr('class', 'ge-datavalue')
                .html( obj.format(entry[obj.key]) )

        }

    } )

    container.classList.remove('ge-hidden')

    if(tracker) { tracker.registerEvent('load', entry.ons_id) }

    drawMap(entry)

}

// code starts with

const params = getQueryParameters()

console.log(params)

if(params.id) {

    const entry = data.find( row => row.ons_id === params.id )

    const copy = decodeURIComponent(params.copy || '')

    if(entry) {
        generate(entry, copy, params)
    }

}